import { useNavigate, useOutletContext } from 'react-router-dom'

import { PersonalPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import Personal from 'modules/employees/components/Personal'
import { RouteContext } from 'modules/profile/pages/RootPage'

const ProfilePersonalRoute = () => {
  const { employee } = useCurrentSession()
  const { canSeePersonalInfo } = useOutletContext<RouteContext>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    // it can also be null if it's still loading the permission
    // that's why we check for false specifically
    if (canSeePersonalInfo === false) {
      // Return to the profile in case the user doesn't have permission
      // to see the personal info.
      // This can happen if you navigate directly to /personal with your browser.
      navigate(navigation.profile.fullPath())
    }
  }, [canSeePersonalInfo])

  if (!employee) {
    throw new Error('Current employee not found')
  }

  const { data, loading } = useQuery(PersonalPageDocument, {
    variables: {
      employeeId: employee.id,
      usageGroupSlugs: ['general-information', 'identification-number', 'basic-information'],
    },
  })

  const customResourceFieldsData = compact(
    data?.customFields?.resourceFields.filter((resourceField) => !!resourceField?.field) ?? []
  )
  const customValuesData =
    data?.customFields?.resourceFields?.flatMap((rf) => rf.field?.value ?? []) ?? []

  if (loading) {
    return <Loading />
  }

  return (
    <Personal
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default ProfilePersonalRoute
